import { useTheme } from '@vlabs/uikit';

function useAppTheme() {
  const { theme, setTheme } = useTheme();

  const setAppTheme = (nextTheme) => {
    window.localStorage.setItem('data-theme', nextTheme);
    setTheme(nextTheme);
  };

  return {
    theme,
    setTheme: setAppTheme,
    isLightTheme: theme !== 'dark',
  };
}

export { useAppTheme };
